import { ComponentProps } from "react";

import { Step } from "../../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import CheckboxOptInMedicalStep from "../Components/CheckboxOptInMedicalStep";
import { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import AllMedicalQuestionsEvaluator from "./AllMedicalQuestionsEvaluator";
import ComposedUseCreateMedicalNonCanLeadResult from "./ComposedUseCreateMedicalNonCanLeadResult";

const ConfiguredCheckboxOptInMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  CheckboxOptInMedicalStep({
    ...props,
    nextStep: Step.scheduling,
    medicalQualificationEvaluator: AllMedicalQuestionsEvaluator,
    useCreateNonCandidateLeadResult: ComposedUseCreateMedicalNonCanLeadResult
  });

const ComposedCheckboxOptInMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredCheckboxOptInMedicalStep>
>({
  Component: ConfiguredCheckboxOptInMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSaveCustomerNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSaveCustomerNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedCheckboxOptInMedicalStep;
